import { render, staticRenderFns } from "./OrderCreator.vue?vue&type=template&id=406d1d5c&scoped=true&"
import script from "./OrderCreator.vue?vue&type=script&lang=js&"
export * from "./OrderCreator.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreator.vue?vue&type=style&index=0&id=406d1d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d1d5c",
  null
  
)

export default component.exports